/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_NameInputs */

const en_features_plan_name = /** @type {(inputs: Features_Plan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength, 8 weeks`)
};

const pl_features_plan_name = /** @type {(inputs: Features_Plan_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siła, 8 tygodni`)
};

/**
* | output |
* | --- |
* | "Strength, 8 weeks" |
*
* @param {Features_Plan_NameInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_name = /** @type {((inputs?: Features_Plan_NameInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_NameInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_name(inputs)
	return en_features_plan_name(inputs)
});